import CrossteamSite from "./components/CrossteamSite";

function App() {
  return <CrossteamSite />;
}

export default App;
